import React from 'react';

const ChevronLeft = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20">
    <path d="M14 20a.5.5 0 0 0 .354-.853l-8.646-8.646 8.646-8.646a.5.5 0 0 0-.707-.707l-9 9a.5.5 0 0 0 0 .707l9 9a.498.498 0 0 0 .354.146z" />
  </svg>
);

export default ChevronLeft;
